import { render, staticRenderFns } from "./CheckForDupsPage.vue?vue&type=template&id=3404f445&scoped=true"
import script from "./CheckForDupsPage.vue?vue&type=script&lang=js"
export * from "./CheckForDupsPage.vue?vue&type=script&lang=js"
import style0 from "./CheckForDupsPage.vue?vue&type=style&index=0&id=3404f445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3404f445",
  null
  
)

export default component.exports